import { ProductStockInformation } from './product-stock-information';

export class ProductStockError extends Error {
  public productsStockInformation: ProductStockInformation[];

  constructor(message, productsStockInformation) {
    super(message);
    this.name = this.constructor.name;
    this.productsStockInformation = productsStockInformation;
  }
}
